var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('router-view',{attrs:{"name":"TheHeader"}}),_c('b-container',[_c('router-view')],1),_c('router-view',{attrs:{"name":"TheFooter"}}),_c('a-back-top'),_c('b-container',[_c('hr')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }